var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDydx(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.636 2 3 29.997H9.03L28.765 2h-6.13zM9.657 2l5.778 8.25-3.015 4.5L3.503 2h6.154zm16.085 26.133h-1.55l-5.063-7.212.93-1.22 5.682 8.433zM23.222 30l-6.406-9.125 2.144-2.809 1.196-1.566 1.1 1.634 6.736 10L29.25 30H23.22z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDydx);
export default __webpack_public_path__ + "static/media/DYDX.c21a5345fb2a5fe2db7ebe70c1350fb3.svg";
export { ForwardRef as ReactComponent };